import { toast } from "react-toastify";
import { apicall } from "../../services/api";
import { ALL_USERS, CREATE_USER, ERR_USERS, REMOVE_USER, UPDATE_USER, USER } from "./actionTypes";
import { setAlert } from "./alert.actions";


export const getAllUsers = () => async (dispatch) => {
	try {
		const res = await apicall(`api/v1/admins/`, "get");
		dispatch({
			type: ALL_USERS,
			payload: res.data.data,
		});
	} catch (err) {
		console.log(err);
		dispatch(setAlert(err.response.data.msg, "error"));
	}
};

export const getUser = (userId) => async (dispatch) => {
	try {
		const res = await apicall(`api/v1/admins/getparticular/${userId}`, "get");
		dispatch({
			type: USER,
			payload: res.data,
		});
		toast.success(res.data.message);
		return res.data.data
	} catch (err) {
		dispatch({
			type: ERR_USERS,
			payload: { msg: err.response.statusText, status: err.response.status },
		});
		toast.error(err.response.data.msg);
	}
};

export const createUser = (data) => async (dispatch) => {
	try {
		const res = await apicall("api/v1/admins/", "post", data);
		dispatch({
			type: CREATE_USER,
			payload: res.data,
		});

		dispatch(getAllUsers());
		// dispatch(setAlert(res.data.message, "success"));
		toast.success(res.data.message);
	} catch (err) {
		dispatch({
			type: ERR_USERS,
			payload: { msg: err.response.statusText, status: err.response.status },
		});
		// dispatch(setAlert(err.response.data.msg, "error"));
		toast.error(err.response.data.msg);
	}
};

export const updateUser = (userId, data) => async (dispatch) => {
	try {
		const res = await apicall(`api/v1/admins/${userId}`, "patch", data);
		dispatch({
			type: UPDATE_USER,
			payload: res.data,
		});
		dispatch(getAllUsers());
		// dispatch(setAlert(res.data.message, "success"));
		toast.success(res.data.message);
	} catch (err) {

		dispatch({
			type: ERR_USERS,
			payload: { msg: err.response.statusText, status: err.response.status },
		});
		dispatch(setAlert(err.response.data.msg, "error"));
	}
};

export const deleteUser = (userId) => async (dispatch) => {
	try {
		const res = await apicall(`api/v1/admins/${userId}`, "delete");
		dispatch({ type: REMOVE_USER, payload: userId });
		dispatch(getAllUsers())
		toast.success(res.data.message);
	} catch (err) {
		console.log("err", err);
		dispatch({
			type: ERR_USERS,
			payload: { msg: err.response.msg, status: err.response.status },
		});
		toast.error(err.response.data.msg);
	}
};
